import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';

import { getEdition } from '@jira/platform__application-editions/src/edition.tsx';
import { getTenantContext_DEPRECATED_DO_NOT_USE } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';
import { getApplicationForProject } from '@atlassian/jira-shared-types/src/application.tsx';

/** *************************************
 *         Various action types         *
 ************************************** */
export type UpdateAction = 'ADD' | 'DELETE' | 'EDIT' | 'ATTACH';
export type FetchAction = 'FETCH_PAGE' | 'FETCH_MORE' | 'FETCH_SORTED' | 'FETCH_SURROUNDING';
export type Action = UpdateAction | FetchAction;

type ExperienceDescriptionInput = {
	wasSuccessful: boolean;
	action: Action;
	analyticsSource: string;
	projectType?: ProjectType;
	errorMessage?: string;
	statusCode?: number;
	isEventOccurredAtSelected?: boolean;
	traceId?: string;
	frameworkType?: 'relay';
};

type IssueExperience = 'issueHistory' | 'issueComment';

type ExperienceDescriptionInputWithExperience = ExperienceDescriptionInput & {
	experience: IssueExperience;
};

export const experienceDescription = ({
	experience,
	wasSuccessful,
	action,
	analyticsSource,
	projectType,
	errorMessage,
	statusCode,
	isEventOccurredAtSelected,
	traceId,
	frameworkType,
}: ExperienceDescriptionInputWithExperience) => {
	let application = null;
	let edition = null;

	if (projectType !== undefined) {
		try {
			const { appEditions } = getTenantContext_DEPRECATED_DO_NOT_USE();
			application = getApplicationForProject(projectType);
			edition = getEdition(application, appEditions);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			// application and edition already default to null.
		}
	}

	return {
		experience,
		wasExperienceSuccesful: wasSuccessful,
		analyticsSource,
		application,
		edition,
		additionalAttributes: {
			action,
			...(typeof statusCode !== 'undefined' ? { statusCode } : null),
			...(errorMessage !== undefined ? { errorMessage } : null),
			...(isEventOccurredAtSelected !== undefined ? { isEventOccurredAtSelected } : null),
			...(traceId !== undefined ? { traceId } : null),
			...(frameworkType !== undefined ? { frameworkType } : null),
		},
	};
};
